import React from "react";
import cx from "classnames";
export default ({ label, name, className }) => {
    return (
        <label
            htmlFor={name}
            className={cx("block text-sm font-medium text-gray-700", className)}
        >
            {label}
        </label>
    );
};
